/**
 * @generated SignedSource<<1bce5b35349cd4550da965c94478b555>>
 * @relayHash 8f72766dbc3288a69e1f166ec6dfe741
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0

import type { ConcreteRequest } from 'relay-runtime';
export type usePageIncludeMacroQueryByTitleQuery$variables = {
  blogSpaceKey: string;
  blogTitle: string;
  includeBlog: boolean;
  includeRaw: boolean;
  includeSplit: boolean;
  postingDay: string;
  rawSpaceKey: string;
  rawTitle: string;
  splitSpaceKey: string;
  splitTitle: string;
};
export type usePageIncludeMacroQueryByTitleQuery$data = {
  readonly blogContent?: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly rawContent?: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly splitContent?: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type usePageIncludeMacroQueryByTitleQuery = {
  response: usePageIncludeMacroQueryByTitleQuery$data;
  variables: usePageIncludeMacroQueryByTitleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogSpaceKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogTitle"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeBlog"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRaw"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeSplit"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postingDay"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rawSpaceKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rawTitle"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "splitSpaceKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "splitTitle"
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v11 = {
  "kind": "Literal",
  "name": "type",
  "value": "page"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v12/*: any*/),
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          (v12/*: any*/)
        ]
      },
      {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              },
              {
                "concreteType": "EmbeddedMediaToken",
                "kind": "LinkedField",
                "name": "mediaToken",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "token"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v14 = [
  {
    "condition": "includeRaw",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "rawContent",
        "args": [
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "rawSpaceKey"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "rawTitle"
          },
          (v11/*: any*/)
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v13/*: any*/)
      }
    ]
  },
  {
    "condition": "includeSplit",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "splitContent",
        "args": [
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "splitSpaceKey"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "splitTitle"
          },
          (v11/*: any*/)
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v13/*: any*/)
      }
    ]
  },
  {
    "condition": "includeBlog",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "blogContent",
        "args": [
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "postingDay",
            "variableName": "postingDay"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "blogSpaceKey"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "blogTitle"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "blogpost"
          }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": (v13/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePageIncludeMacroQueryByTitleQuery",
    "selections": (v14/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePageIncludeMacroQueryByTitleQuery",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "8f72766dbc3288a69e1f166ec6dfe741",
    "id": "4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0",
    "metadata": {},
    "name": "usePageIncludeMacroQueryByTitleQuery",
    "operationKind": "query",
    "text": "query usePageIncludeMacroQueryByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$includeRaw:Boolean!,$splitSpaceKey:String!,$splitTitle:String!,$includeSplit:Boolean!,$blogSpaceKey:String!,$blogTitle:String!,$postingDay:String!,$includeBlog:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,type:\"page\",first:1)@include(if:$includeRaw){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,type:\"page\",first:1)@include(if:$includeSplit){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},blogContent:content(spaceKey:$blogSpaceKey,title:$blogTitle,type:\"blogpost\",postingDay:$postingDay,first:1)@include(if:$includeBlog){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
  }
};
})();

(node as any).hash = "f95c0a76906580963b7866b01f678dd2";

export default node;
